import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import CustomRadio from './CustomRadio';
import Tag from './Tag';

interface OfferProps {
  offers: OfferOption[];
  selectedOfferCode: SelectedOffer['code'];
  setSelectedOffer?: (offer: SelectedOffer) => void;
}

const Offers = ({ offers, selectedOfferCode, setSelectedOffer }: OfferProps) => {
  const isSingleOffer = offers.length === 1;

  return (
    <>
      {offers.map((offer, index) => {
        const {
          benefits,
          billingFrequency,
          code,
          currentPrice,
          currentPriceDisplayOverride,
          billingFrequencyOverride,
          isBestValue,
          originalPrice,
          originalPriceDisplayOverride,
          title,
        } = offer;
        const isSelected = selectedOfferCode === code;
        const currentPriceToDisplay = currentPriceDisplayOverride || currentPrice;
        const hasDiscount = originalPrice !== currentPrice;
        const originalPriceToDisplay = originalPriceDisplayOverride || originalPrice;
        return (
          <div
            key={`offer-card-${index}`}
            id={code}
            onClick={() =>
              setSelectedOffer({
                billingFrequency,
                code,
                currentPrice,
                originalPrice,
              })
            }
            className={clsx(
              'tw-relative tw-mb-20 tw-block tw-cursor-pointer tw-rounded-10 tw-border  tw-border-solid tw-border-slate-200 tw-px-16 tw-py-20',
              {
                'selected tw-border-0 tw-bg-primary-black tw-shadow-[0_0_8px_1px_rgba(121,130,149,1)]':
                  isSelected,
                'tw-pointer-events-none': isSingleOffer,
              }
            )}
          >
            <div className="tw-flex tw-items-center">
              <CustomRadio isSelected={isSelected} />
              <h2
                className={clsx(
                  'tw-m-0 tw-font-serif tw-text-[26px] tw-font-bold tw-text-primary-black',
                  {
                    'tw-text-white': isSelected,
                  }
                )}
              >
                {title}
              </h2>
              {isBestValue && !isSingleOffer && <Tag name="Best Value" className="best-value" />}
              {isSingleOffer && (
                <Tag name="Best Value" className="tw-absolute -tw-top-8 tw-right-12" />
              )}
            </div>
            <div className="tw-mt-36 tw-flex tw-items-center">
              <span
                className={clsx('tw-font-sans tw-font-medium tw-text-primary-black', {
                  'tw-text-white': isSelected,
                })}
              >
                ${currentPriceToDisplay.toFixed(2)}
              </span>{' '}
              {hasDiscount && (
                <span className="tw-ml-6 tw-font-sans tw-font-medium tw-text-gray-400 tw-line-through">
                  ${originalPriceToDisplay.toFixed(2)}
                </span>
              )}
              {billingFrequencyOverride && (
                <span
                  className={clsx('tw-ml-6 tw-font-sans tw-font-medium tw-text-primary-black', {
                    'tw-text-white': isSelected,
                  })}
                >
                  {billingFrequencyOverride}
                </span>
              )}
            </div>
            <div
              className={clsx(
                'tw-mt-2 tw-font-sans tw-text-body-sm tw-text-gray-500 xs:tw-text-subtitle-serif',
                {
                  'tw-text-neutral-400': isSelected,
                }
              )}
            >
              {ReactHtmlParser(benefits)}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Offers;
